var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.072,
    height: 14.232,
    viewBox: "0 0 30.072 14.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    transform: "translate(-329.464 -105.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M5.4,21.6a5,5,0,0,1,0-10v2a3,3,0,0,0,0,6,2.946,2.946,0,0,0,3-3h2A5.081,5.081,0,0,1,5.4,21.6Z",
    transform: "translate(344.455 97.153) rotate(45)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M16.6,10.4v-2a2.946,2.946,0,0,0,3-3,3,3,0,1,0-6,0h-2a5,5,0,0,1,10,0A5.015,5.015,0,0,1,16.6,10.4Z",
    transform: "translate(344.545 97.063) rotate(45)",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M9.6,13.3a.908.908,0,0,1-.7-.3.967.967,0,0,1,0-1.4l2.8-2.8a.99.99,0,0,1,1.4,1.4L10.3,13A.908.908,0,0,1,9.6,13.3Z",
    transform: "translate(344.492 97.116) rotate(45)",
    fill: "#cdcdcd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.264203d8b125830fc0f3d39161a23ae5.svg";
export { ForwardRef as ReactComponent };